import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
		<defs>
			<style>{".d{fill:#fff}"}</style>
		</defs>
		<g id="b">
			<path
				d="M47.88 397.43 262.91 49.52l84.21 52.05L164.52 397M253.59 287.87l67.72 109.56 116.12-.43-125.64-203.28"
				className="d"
			/>
		</g>
	</svg>
);
export { SvgComponent as LogoSVG };
